import { useIntl } from 'react-intl';

export const useCustomerRatingsHistogramMessages = () => {
  const { formatMessage } = useIntl();

  const getLabel = (rating: number) =>
    formatMessage(
      {
        id: 'customerRatings.histogram.label',
        defaultMessage: '{rating, plural, one {# Stern} other {# Sterne}}',
      },
      { rating },
    );

  const getLinkLabel = (rating: number, count: number) =>
    formatMessage(
      {
        id: 'customerRatings.histogram.link.label',
        defaultMessage:
          'Alle Bewertungen mit {rating, plural, one {# Stern} other {# Sternen}} anzeigen ({count})',
      },
      { rating, count },
    );

  return {
    getLabel,
    getLinkLabel,
  };
};
